import { useQuery } from "react-query";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import MemosDataService from "../../services/memos-data-service/MemosDataService";
import { IMemoAutoText } from "../../services/offline-data-service/Models";
import { RestError } from "../../services/rest-service/RestService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";

export type UseMemoAutoTextParameters = {
    customerID: number,
    groupID: number,
    objectType: eLynxObjectTypeEnum,
    offline: boolean
} & BaseUseQueryParameters<Array<IMemoAutoText>>

export function useMemoAutoText({
    customerID,
    groupID,
    objectType,
    offline,
    enabled,
    onError,
    onSuccess,
    refreshSeconds
}: UseMemoAutoTextParameters) {
    return useQuery<Array<IMemoAutoText>, RestError>(
        keys.memoAutoText(customerID, groupID, objectType, offline),
        ({ signal }) => {
            return MemosDataService.getMemoAutoText(customerID, groupID, objectType, offline, signal);
        },
        {
            enabled,
            onError: onError,
            onSuccess: onSuccess,
            refetchInterval: refreshSeconds ? refreshSeconds  * 1000 : false
        }
    );
}
